<template>
  <div class="mb-15">
    <v-row no-gutters>
      <page-title value="クラス設定"></page-title>
      <v-spacer />
      <v-btn @click="createDialog = true" color="primary" variant="flat">
        <v-icon start>mdi-plus</v-icon>
        クラス作成
      </v-btn>
    </v-row>

    <!-- 年度 -->
    <v-card variant="flat" class="mt-4 pa-2" color="grey-lighten-5">
      <v-container>
        <v-row align="center">
          <v-col cols="3" class="pl-0">
            <v-text-field
              v-model="yearFilterValue"
              :disabled="loading"
              type="number"
              hide-details="auto"
              variant="outlined"
              density="compact"
            >
              <template #append-inner>
                <span class="text-medium-emphasis text-no-wrap align-self-center">年度</span>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="9" align-self="center">
            <v-btn
              @click="listClass"
              :loading="loading"
              color="primary"
              variant="flat"
            >
              検索
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <!-- <v-data-table
      :headers="headers"
      :items="classList"
      :loading="loading"
      hide-default-footer="auto"
      class="mt-6"
      disable-sort
      disable-pagination
      :items-per-page="-1"
    >
    -->
    <v-data-table
      class="pt-6"
      :headers="headers"
      :items="classList"
      :items-per-page="-1"
      :loading="loading"
      color="primary"
    >
      <template v-slot:loading>
        <v-skeleton-loader type="table-tbody"></v-skeleton-loader>
      </template>

      <template v-slot:item.year="{ item }">
        <div class="d-flex align-center">
          {{ item.year }}
          <v-tooltip bottom>
            <template v-slot:activator="{ props }">
              <v-icon
                v-if="item.isActive"
                class="ml-1"
                x-small
                color="success"
                v-bind="props"
                >mdi-circle</v-icon
              >
            </template>
            <span>今年度</span>
          </v-tooltip>
        </div>
      </template>

      <template v-slot:item.childrenAge="{ item }">
        {{ `${item.childrenAge}歳` }}
      </template>

      <template v-slot:item.createdAt="{ item }">
        {{ formatDate(item.createdAt) }}
      </template>

      <template v-slot:item.edit="{ item }">
        <v-btn
          @click="clickClass(item)"
          :disabled="loading"
          color="primary"
          small
          variant="flat"
          block
        >
          編集
        </v-btn>
      </template>

      <template v-slot:item.children="{ item }">
        <v-btn
          @click="searchChildren(item.classId)"
          :disabled="loading"
          color="primary"
          small
          variant="outlined"
          block
        >
          園児詳細
        </v-btn>
      </template>

      <template v-slot:item.duplicate="{ item }">
        <v-btn
          @click="clickDuplicate(item)"
          :disabled="loading"
          color="secondary"
          variant="outlined"
          small
        >
          <v-icon start>mdi-file-multiple-outline</v-icon>
          複製
        </v-btn>
      </template>
      <template #bottom></template>
    </v-data-table>

    <!-- children dialog -->
    <v-dialog v-model="childrenDialog" width="700px">
      <v-card>
        <v-card-title>園児詳細</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-alert type="info" variant="outlined" color="primary" density="compact">
                  チェックボックスでクラスへの所属/解除を切り替え
                </v-alert>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <v-data-table
                  v-model="childrenList"
                  :headers="childrenTableHeaders"
                  :items="allChildrenList"
                  item-value="childId"
                  :loading="loading"
                  show-select
                  density="compact"
                  hide-default-footer
                  :items-per-page="-1"
                  color="primary"
                >
                  <template v-slot:item.children="{ item }">
                    {{ `${item.lastName} ${item.firstName}` }}
                  </template>
                  <template v-slot:item.gender="{ item }">
                    <v-chip
                      v-if="item.gender == 'male'"
                      color="light-blue"
                      dark
                      small
                      >男性</v-chip
                    >

                    <v-chip v-else color="pink lighten-2" dark small
                      >女性</v-chip
                    >
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-container>
            <v-row>
              <v-btn @click="childrenDialog = false" color="grey" text
                >キャンセル
              </v-btn>
              <v-spacer />
              <v-btn
                @click="updateClassChildren"
                :loading="loading"
                color="primary"
                variant="flat"
              >
                保存
              </v-btn>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- duplicate dialog -->
    <v-dialog v-model="duplicateDialog" width="700px">
      <v-form v-model="duplicateFormValid">
        <v-card>
          <v-card-title>クラスを複製</v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-alert color="primary" variant="outlined" type="info" density="compact">
                    複製元のクラスに所属する園児は、複製先のクラスへ自動的に所属
                  </v-alert>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="6"> クラス名 </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="duplicateInput.to.className"
                    :rules="[required]"
                    variant="outlined"
                    clearable
                    hide-details
                    density="compact"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row align="center">
                <v-col cols="6"> 対象年度 </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="duplicateInput.to.year"
                    :rules="[required]"
                    type="number"
                    variant="outlined"
                    hide-details
                    density="compact"
                    suffix="年度"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row align="center">
                <v-col cols="6"> 園児の年齢 </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="duplicateInput.to.childrenAge"
                    :rules="[required]"
                    type="number"
                    suffix="歳"
                    variant="outlined"
                    hide-details
                    density="compact"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-container>
              <v-row>
                <v-btn @click="duplicateDialog = false" color="grey" text>
                  キャンセル
                </v-btn>
                <v-spacer />
                <v-btn
                  @click="duplicateClass"
                  :loading="loading"
                  :disabled="!duplicateFormValid"
                  color="primary"
                  variant="flat"
                >
                  複製
                </v-btn>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- create dialog -->
    <class-dialog-container
      dialogType="create"
      v-model:isOpen="createDialog"
    ></class-dialog-container>

    <!-- update dialog -->
    <class-dialog-container
      dialogType="update"
      v-model:isOpen="updateDialog"
    ></class-dialog-container>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/atoms/PageTitle.vue";
import ClassDialogContainer from "@/containers/ClassDialogContainer.vue";
import { classEditModule } from "@/store/dataModules/classEditModule";
import { classModule } from "@/store/dataModules/classModule";
import LocalDataService from "@/service/LocalDataService";
import { NurseryClassResponse, NurseryChildResponse } from "chaild-api/lib";
import dayjs from "dayjs";
import ApiChildren from "../../api/ApiChildren";
import ApiClass from "@/api/ApiClass";
import ValidationMixin from "@/mixins/ValidationMixin";

export default defineComponent({
  name: "ClassSetting",

  mixins: [ValidationMixin],

  components: {
    PageTitle,
    ClassDialogContainer,
  },

  async mounted() {
    await this.listClass();
    await this.getAllChildren();
  },

  data() {
    return {
      loading: false,
      createDialog: false,
      updateDialog: false,
      childrenDialog: false,
      duplicateDialog: false,
      yearFilterValue: "",
      selectedClassId: 0,
      headers: [
        { title: "年度", key: "year", sortable: false },
        { title: "クラス名", key: "className", sortable: false },
        { title: "年齢", key: "childrenAge", sortable: false },
        { title: "作成日", key: "createdAt", sortable: false },
        { title: "園児", key: "children", sortable: false },
        { title: "編集", key: "edit", sortable: false },
        { title: "複製", key: "duplicate", sortable: false },
      ],
      childrenList: [] as number[],
      allChildrenList: [] as NurseryChildResponse[],
      duplicateInput: {
        classId: "" as string | number,
        to: {
          className: "",
          childrenAge: 0,
          year: 2021 as number,
        },
      },
      duplicateFormValid: false,
      childrenTableHeaders: [
        { title: "園児", key: "children", sortable: false },
        { title: "性別", key: "gender", sortable: false },
      ],
    };
  },

  watch: {
    createDialog: {
      handler(val: boolean) {
        if (!val) {
          this.clearValues();
          this.listClass();
        }
      },
    },
    updateDialog: {
      handler(val: boolean) {
        if (!val) {
          this.clearValues();
          this.listClass();
        }
      },
    },
  },

  computed: {
    classList: function (): NurseryClassResponse[] {
      return classModule.classes;
    },
  },

  methods: {
    async listClass() {
      this.loading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await classModule.listClass({
          nurseryId: nurseryId,
          year: this.yearFilterValue,
        });
      }
      this.loading = false;
    },
    async searchChildren(classId: number) {
      this.loading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        this.selectedClassId = classId;
        const response = await ApiChildren.listChildren({
          nurseryId,
          classId,
        }).catch();
        if (response) {
          this.childrenList = response.map((c: NurseryChildResponse) => c.childId);
          this.childrenDialog = true;
        } else {
          this.childrenList = [];
        }
      }
      this.loading = false;
    },
    async getAllChildren() {
      this.loading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        const response = await ApiChildren.listChildren({
          nurseryId,
        }).catch();
        if (response) {
          this.allChildrenList = response;
        } else {
          this.allChildrenList = [];
        }
      }
      this.loading = false;
    },
    async duplicateClass() {
      this.loading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        const response = await ApiClass.duplicateClass({
          nurseryId,
          ...this.duplicateInput,
        }).catch(() => (this.loading = false));
        if (response) {
          alert("クラスを複製しました");
          this.duplicateDialog = false;
          await this.listClass();
        }
      }
      this.loading = false;
    },
    async updateClassChildren() {
      this.loading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        const response = await ApiChildren.updateClassChildren({
          nurseryId,
          classId: this.selectedClassId,
          childrenIds: this.childrenList,
        }).catch(() => (this.loading = false));
        if (response) {
          this.childrenDialog = false;
          alert("保存しました");
        }
      }
      this.loading = false;
    },
    clickClass(value: NurseryClassResponse) {
      if (value) {
        classEditModule.setClassId(value.classId as any);
        classEditModule.setClassName(value.className);
        classEditModule.setYear((value as any).year);
        classEditModule.setChildrenAge(String(value.childrenAge));
        this.updateDialog = true;
      }
    },
    clickDuplicate(value: NurseryClassResponse) {
      this.duplicateDialog = true;
      this.duplicateInput.classId = value.classId;
      this.duplicateInput.to.className = `${value.className}のコピー`;
      this.duplicateInput.to.childrenAge = value.childrenAge;
      this.duplicateInput.to.year = value.year || 2021;
    },
    clearValues() {
      classEditModule.setClassName("");
    },
    formatDate(value: string): string {
      if (!value) {
        return "";
      }
      return dayjs(value).format("YYYY/MM/DD");
    },
  },
});
</script>
